import { useNavigate } from "react-router-dom"
import { Button } from "reactstrap"

const QuotationHeader = ({ total = 0, customer = null }) => {
  const navigate = useNavigate()
  return (
    <div className="d-flex justify-content-between align-items-center mb-4">
      <div>
        <h5 className="mb-0 fw-semibold">Quotations</h5>
        <div>Total: {total ?? 0}</div>
      </div>

      <div className="d-flex gap-2">
        <Button
          size="sm"
          color="outline-primary"
          onClick={() =>
            navigate(`/quotation-list/add?cuid=${customer?.cuid ?? ""}`)
          }
          className="d-flex align-items-center"
        >
          <i className="bx bx-plus me-1"></i>
          Add Quotation
        </Button>
      </div>
    </div>
  )
}

export default QuotationHeader
